var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-store" }),
        _vm._v(_vm._s(_vm.$t("Store Info")) + " ")
      ]),
      _vm.CUSTOMER !== "ROGERS"
        ? _c(
            "v-row",
            { staticClass: "pa-0 ma-0" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center pb-0",
                  attrs: { cols: "2" }
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "close-on-content-click": false,
                        "content-class": "columnMenu"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "manage-btn btn",
                                        attrs: { text: "", small: "" }
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("Manage Columns")) +
                                        " "
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        class: { rotate: _vm.menuOpen },
                                        attrs: { right: "" }
                                      },
                                      [_vm._v(" mdi-chevron-down ")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2624018056
                      ),
                      model: {
                        value: _vm.menuOpen,
                        callback: function($$v) {
                          _vm.menuOpen = $$v
                        },
                        expression: "menuOpen"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "column-card" },
                        [
                          _c("v-card-title", { staticClass: "column-header" }, [
                            _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                          ]),
                          _c("v-divider"),
                          _c(
                            "v-list",
                            { staticClass: "select-all", attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value": _vm.isAllSelected,
                                      "hide-details": ""
                                    },
                                    on: { change: _vm.toggleSelectAll }
                                  }),
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Select All")) + " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            { staticClass: "column-list" },
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                _vm._l(_vm.computedHeaders, function(header) {
                                  return _c(
                                    "v-list-item",
                                    { key: header.value },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          value: header.text,
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.visibleColumns,
                                          callback: function($$v) {
                                            _vm.visibleColumns = $$v
                                          },
                                          expression: "visibleColumns"
                                        }
                                      }),
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "column-text" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(header.text) + " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            { staticClass: "column-footer" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    background: "#c57171",
                                    color: "#ffffff !important",
                                    width: "80px"
                                  },
                                  attrs: {
                                    color: "error",
                                    text: "",
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.menuOpen = false
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { width: "80px" },
                                  attrs: { color: "primary", small: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.menuOpen = false
                                      _vm.saveVisibleColumns()
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-center pa-0 mt-6",
                  attrs: { cols: "1" }
                },
                [_c("v-divider", { attrs: { vertical: "" } })],
                1
              ),
              _c(
                "v-col",
                { staticClass: "d-flex flex-column", attrs: { cols: "9" } },
                [
                  _c(
                    "section",
                    { staticClass: "searchArea d-flex" },
                    [
                      _vm._l(_vm.searchInputs.text, function(searchInput) {
                        return _c("v-text-field", {
                          key: searchInput.name,
                          staticClass: "form-input ml-3",
                          staticStyle: { width: "25%" },
                          attrs: {
                            label: _vm.$t(searchInput.label),
                            placeholder: _vm.$t(
                              _vm.getPlaceholder(searchInput)
                            ),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchStores()
                            }
                          },
                          model: {
                            value: searchInput.value,
                            callback: function($$v) {
                              _vm.$set(searchInput, "value", $$v)
                            },
                            expression: "searchInput.value"
                          }
                        })
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search ml-3",
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              return _vm.searchStores()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Search")) + " ")]
                      )
                    ],
                    2
                  ),
                  _c(
                    "section",
                    { staticClass: "searchArea d-flex mt-2" },
                    [
                      _vm._l(_vm.searchInputs.select, function(
                        searchInput,
                        idx
                      ) {
                        return _c("v-select", {
                          key: searchInput.name,
                          staticClass: "form-select ml-3",
                          staticStyle: { width: "20%" },
                          attrs: {
                            label: _vm.$t(searchInput.label),
                            placeholder: _vm.$t(
                              _vm.getPlaceholder(searchInput)
                            ),
                            items: searchInput.options,
                            "no-data-text": _vm.$t("No data available"),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.setSelectableAreaNames(idx)
                            }
                          },
                          model: {
                            value: searchInput.value,
                            callback: function($$v) {
                              _vm.$set(searchInput, "value", $$v)
                            },
                            expression: "searchInput.value"
                          }
                        })
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn type-search ml-3",
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              return _vm.clear()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Clear")) + " ")]
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "col-12 d-flex pt-0 pl-0",
          style: this.CUSTOMER === "ROGERS" ? "margin-top: 35px;" : ""
        },
        [
          _vm.CUSTOMER === "ROGERS"
            ? _c("div", { staticClass: "col-3 pl-0 pt-0" }, [
                _c("div", { staticClass: "filters mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "filters-scroll mt-14 pl-2 pb-12" },
                    [
                      _c("div", { staticClass: "header pl-6 pt-8" }, [
                        _c("span", { staticClass: "settings-title" }, [
                          _vm._v("Column Settings")
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "reset d-flex align-center",
                            on: {
                              click: function($event) {
                                return _vm.clickFilter()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { size: "18" } },
                              [_vm._v("mdi-update")]
                            ),
                            _c("span", { staticClass: "text-caption" }, [
                              _vm._v("Reset")
                            ])
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "pt-3" },
                        [
                          _c("v-select", {
                            ref: "countryMenu",
                            staticClass: "form-select",
                            attrs: {
                              items: _vm.filteredCountries,
                              label: "Select Country",
                              placeholder: "Select Country",
                              outlined: "",
                              "hide-details": "",
                              "menu-props": {
                                maxHeight: 420,
                                transition: "slide-y-transition"
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-item",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "pa-3" },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input search",
                                            attrs: {
                                              placeholder:
                                                "Input the store name or code",
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                              "prepend-inner-icon":
                                                "mdi-magnify"
                                            },
                                            model: {
                                              value: _vm.searchCountry,
                                              callback: function($$v) {
                                                _vm.searchCountry = $$v
                                              },
                                              expression: "searchCountry"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-divider")
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "item",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.toggleItem(
                                                "country",
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "checkBox",
                                            attrs: {
                                              "input-value":
                                                _vm.searchInput.country ===
                                                item,
                                              readonly: "",
                                              "hide-details": ""
                                            }
                                          }),
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "list-item" },
                                            [_vm._v(" " + _vm._s(item) + " ")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "count" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.searchInput.country ? 1 : 0
                                              ) +
                                              " of " +
                                              _vm._s(_vm.allCountries.length) +
                                              " Countries "
                                          ),
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-down")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1888586650
                            ),
                            model: {
                              value: _vm.searchInput.country,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInput, "country", $$v)
                              },
                              expression: "searchInput.country"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("v-select", {
                            ref: "regionMenu",
                            staticClass: "form-select",
                            attrs: {
                              items: _vm.filteredRegions,
                              label: "Select Region",
                              placeholder: "Select Region",
                              outlined: "",
                              "hide-details": "",
                              "menu-props": {
                                maxHeight: 420,
                                transition: "slide-y-transition"
                              },
                              disabled: !_vm.searchInput.country
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-item",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "pa-3" },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input search",
                                            attrs: {
                                              placeholder:
                                                "Input the store name or code",
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                              "prepend-inner-icon":
                                                "mdi-magnify"
                                            },
                                            model: {
                                              value: _vm.searchRegion,
                                              callback: function($$v) {
                                                _vm.searchRegion = $$v
                                              },
                                              expression: "searchRegion"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-divider")
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "item",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.toggleItem(
                                                "region",
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "input-value":
                                                _vm.searchInput.region === item,
                                              readonly: "",
                                              "hide-details": ""
                                            }
                                          }),
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "list-item" },
                                            [_vm._v(" " + _vm._s(item) + " ")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "count" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.searchInput.region ? 1 : 0
                                              ) +
                                              " of " +
                                              _vm._s(_vm.totalRegions) +
                                              " Regions "
                                          ),
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-down")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              728699096
                            ),
                            model: {
                              value: _vm.searchInput.region,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInput, "region", $$v)
                              },
                              expression: "searchInput.region"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("v-select", {
                            ref: "cityMenu",
                            staticClass: "form-select",
                            attrs: {
                              items: _vm.filteredCities,
                              label: "Select City",
                              placeholder: "Select City",
                              outlined: "",
                              "hide-details": "",
                              "menu-props": {
                                maxHeight: 420,
                                transition: "slide-y-transition"
                              },
                              disabled: !_vm.searchInput.region
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-item",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "pa-3" },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "form-input search",
                                            attrs: {
                                              placeholder:
                                                "Input the store name or code",
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "",
                                              "prepend-inner-icon":
                                                "mdi-magnify"
                                            },
                                            model: {
                                              value: _vm.searchCity,
                                              callback: function($$v) {
                                                _vm.searchCity = $$v
                                              },
                                              expression: "searchCity"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-divider")
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "item",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.toggleItem(
                                                "city",
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "input-value":
                                                _vm.searchInput.city === item,
                                              readonly: "",
                                              "hide-details": ""
                                            }
                                          }),
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "list-item" },
                                            [_vm._v(" " + _vm._s(item) + " ")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "count" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.searchInput.city ? 1 : 0
                                              ) +
                                              " of " +
                                              _vm._s(_vm.totalCities) +
                                              " Cities "
                                          ),
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-down")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              821818840
                            ),
                            model: {
                              value: _vm.searchInput.city,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInput, "city", $$v)
                              },
                              expression: "searchInput.city"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("v-text-field", {
                            key: _vm.searchInputsRogers.text[0].name,
                            staticClass: "form-input mb-4",
                            attrs: {
                              label: _vm.$t(
                                _vm.searchInputsRogers.text[0].label
                              ),
                              placeholder: _vm.$t(
                                _vm.getPlaceholder(
                                  _vm.searchInputsRogers.text[0]
                                )
                              ),
                              outlined: "",
                              "hide-details": "",
                              clearable: ""
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchStores()
                              }
                            },
                            model: {
                              value: _vm.searchInputsRogers.text[0].value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchInputsRogers.text[0],
                                  "value",
                                  $$v
                                )
                              },
                              expression: "searchInputsRogers.text[0].value"
                            }
                          }),
                          _c("v-text-field", {
                            key: _vm.searchInputsRogers.text[1].name,
                            staticClass: "form-input mb-4",
                            attrs: {
                              label: _vm.$t(
                                _vm.searchInputsRogers.text[1].label
                              ),
                              placeholder: _vm.$t(
                                _vm.getPlaceholder(
                                  _vm.searchInputsRogers.text[1]
                                )
                              ),
                              outlined: "",
                              "hide-details": "",
                              clearable: ""
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.searchStores()
                              }
                            },
                            model: {
                              value: _vm.searchInputsRogers.text[1].value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchInputsRogers.text[1],
                                  "value",
                                  $$v
                                )
                              },
                              expression: "searchInputsRogers.text[1].value"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "form-select mb-4",
                            attrs: {
                              items: _vm.remainingFields,
                              "item-text": "label",
                              "item-value": "key",
                              "return-object": "",
                              label: "Description Filter",
                              outlined: "",
                              "hide-details": ""
                            },
                            on: { change: _vm.resetFilter },
                            model: {
                              value: _vm.selectedField,
                              callback: function($$v) {
                                _vm.selectedField = $$v
                              },
                              expression: "selectedField"
                            }
                          }),
                          _vm.selectedField &&
                          !_vm.isDropdown(_vm.selectedField)
                            ? _c("v-text-field", {
                                staticClass: "form-input mb-4",
                                attrs: {
                                  label: _vm.$t(_vm.selectedField.label),
                                  placeholder: _vm.$t(
                                    _vm.getPlaceholder(_vm.selectedField)
                                  ),
                                  outlined: "",
                                  "hide-details": "",
                                  clearable: ""
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchStores()
                                  }
                                },
                                model: {
                                  value: _vm.selectedField.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedField, "value", $$v)
                                  },
                                  expression: "selectedField.value"
                                }
                              })
                            : _vm.selectedField
                            ? _c("v-select", {
                                staticClass: "form-select mb-4",
                                attrs: {
                                  items: _vm.selectedField.items,
                                  label: _vm.$t(_vm.selectedField.label),
                                  placeholder: _vm.$t(
                                    _vm.getPlaceholder(_vm.selectedField)
                                  ),
                                  outlined: "",
                                  "hide-details": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.selectedField.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.selectedField, "value", $$v)
                                  },
                                  expression: "selectedField.value"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn type-search mt-2",
                              attrs: { text: "", block: "" },
                              on: {
                                click: function($event) {
                                  return _vm.searchStores()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "col-4 pr-0  pt-0",
              style:
                this.CUSTOMER === "ROGERS"
                  ? "padding: 0px 0px 12px 12px !important;margin-top: -35px;"
                  : ""
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type01 mt-10",
                  attrs: {
                    "item-key": "store",
                    headers:
                      this.CUSTOMER === "ROGERS"
                        ? _vm.defaultHeaderRogers
                        : _vm.storeHeader1,
                    items: _vm.tableItems,
                    "hide-default-footer": true,
                    options: _vm.options,
                    "server-items-length": _vm.totalStores,
                    "single-select": _vm.singleSelect,
                    "show-select": ""
                  },
                  on: {
                    "update:options": function($event) {
                      _vm.options = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.storeName",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("popupSummary", {
                              attrs: {
                                user: _vm.user,
                                item: item,
                                buttonDisabled: _vm.popupDisabled
                              },
                              on: {
                                fireGetStores: function($event) {
                                  return _vm.initiateStoreInfoPage(1)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              class:
                this.CUSTOMER === "ROGERS"
                  ? "col-5 pl-0 pt-0"
                  : "col-8 px-0 pt-0",
              style: this.CUSTOMER === "ROGERS" ? "margin-top: -35px;" : ""
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type01 mt-10 tblBorder",
                  attrs: {
                    "item-key": "store",
                    headers: _vm.showHeaders,
                    items: _vm.tableItems,
                    "hide-default-footer": true,
                    options: _vm.options,
                    "hide-default-header": this.CUSTOMER === "RELIANCE",
                    "server-items-length": _vm.totalStores,
                    "single-select": _vm.singleSelect
                  },
                  on: {
                    "update:options": function($event) {
                      _vm.options = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      this.CUSTOMER === "RELIANCE"
                        ? {
                            key: "header",
                            fn: function(ref) {
                              return [
                                _c(
                                  "thead",
                                  { staticClass: "v-data-table-header" },
                                  [
                                    _c(
                                      "tr",
                                      _vm._l(_vm.computedHeaders, function(
                                        header
                                      ) {
                                        return _c(
                                          "th",
                                          {
                                            key: header.value,
                                            class: [
                                              "text-center",
                                              "bl-1",
                                              "bt-1",
                                              _vm.options.sortDesc.length === 0
                                                ? "sort-icon-header"
                                                : "",
                                              header.sortable
                                                ? "cursor-header"
                                                : ""
                                            ],
                                            attrs: {
                                              colspan: header.children
                                                ? header.children.length
                                                : 1,
                                              rowspan: header.children ? 1 : 2
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortRelianceHeaders(
                                                  header
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(header.text) + " "
                                            ),
                                            header.sortable
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    class: [
                                                      _vm.relianceSortDirection ===
                                                        undefined ||
                                                      _vm.options.sortBy[0] !==
                                                        header.value
                                                        ? "sort-deactive"
                                                        : "sort-active",
                                                      "sort-icon"
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          !_vm.relianceSortDirection ||
                                                            _vm.relianceSortDirection ===
                                                              undefined
                                                            ? "mdi-arrow-up"
                                                            : "mdi-arrow-down"
                                                        )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    ),
                                    _c(
                                      "tr",
                                      _vm._l(_vm.getChildHeaders(), function(
                                        childHeader
                                      ) {
                                        return _c(
                                          "th",
                                          {
                                            key: childHeader.value,
                                            staticClass: "bl-1 bt-1"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(childHeader.text) +
                                                " "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        : null,
                      this.CUSTOMER === "RELIANCE"
                        ? {
                            key: "item",
                            fn: function(props) {
                              return [
                                _c(
                                  "tr",
                                  [
                                    _c("td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(props.item.storeDescription)
                                      )
                                    ]),
                                    _c("td", { staticClass: "text-center" }, [
                                      _vm._v(_vm._s(props.item.country))
                                    ]),
                                    _c("td", { staticClass: "text-center" }, [
                                      _vm._v(_vm._s(props.item.region))
                                    ]),
                                    _c("td", { staticClass: "text-center" }, [
                                      _vm._v(_vm._s(props.item.city))
                                    ]),
                                    _vm._l(props.headers[4].children, function(
                                      subHeaderValue
                                    ) {
                                      return _c(
                                        "td",
                                        {
                                          key: subHeaderValue.value,
                                          staticClass: "text-center"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                props.item[subHeaderValue.value]
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._l(props.headers[5].children, function(
                                      subHeaderValue
                                    ) {
                                      return _c(
                                        "td",
                                        {
                                          key: subHeaderValue.value,
                                          staticClass: "text-center"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                props.item[subHeaderValue.value]
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    }),
                                    _c(
                                      "td",
                                      { staticClass: "text-center" },
                                      [
                                        _c("store-settings-modal", {
                                          attrs: {
                                            user: _vm.user,
                                            store: props.item,
                                            countries: _vm.areas,
                                            timezones: _vm.timezones,
                                            buttonDisabled: _vm.buttonDisabled,
                                            areaAddDisabled: _vm.areaAddDisabled
                                          },
                                          on: {
                                            fireGetStores: function($event) {
                                              return _vm.initiateStoreInfoPage(
                                                _vm.page
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        : null,
                      this.CUSTOMER !== "RELIANCE"
                        ? {
                            key: "item.setting",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("store-settings-modal", {
                                  attrs: {
                                    user: _vm.user,
                                    store: item,
                                    countries: _vm.areas,
                                    timezones: _vm.timezones,
                                    buttonDisabled: _vm.buttonDisabled,
                                    areaAddDisabled: _vm.areaAddDisabled
                                  },
                                  on: {
                                    fireGetStores: function($event) {
                                      return _vm.initiateStoreInfoPage(_vm.page)
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        : null
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c("popupAddSummary", {
              attrs: {
                user: _vm.user,
                buttonDisabled: _vm.buttonDisabled,
                areaAddDisabled: _vm.areaAddDisabled
              },
              on: {
                fireGetStores: function($event) {
                  return _vm.initiateStoreInfoPage(1)
                }
              }
            }),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                class: { hidden: _vm.SingleUser },
                attrs: { disabled: _vm.btnDisabledDelete, text: "" },
                on: {
                  click: function($event) {
                    return _vm.deleteStores()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Delete")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                class: { hidden: _vm.SingleUser },
                attrs: { disabled: _vm.exportDisabled, text: "" },
                on: {
                  click: function($event) {
                    return _vm.exportStores()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Export")) + " ")]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-12 pr-0", staticStyle: { padding: "0px" } },
        [
          _c("Pagination", {
            attrs: {
              pageInfoText: _vm.pageInfoText,
              pageIndex: _vm.pageIndex,
              rowPerPage: _vm.rowPerPage,
              goToPageInput: _vm.goToPageInput,
              totalPages: _vm.totalPages
            },
            on: {
              paging: function($event) {
                return _vm.paging($event)
              },
              updatePage: function($event) {
                return _vm.updatePage($event)
              }
            }
          })
        ],
        1
      ),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }